const url = "https://quizzy-apis.calidig.com:3308";
// const url = "http://localhost:3001";
export default url;